

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import {
  Button,
  Message,
  Grid,
  Divider,
} from 'semantic-ui-react';
import _ from 'lodash';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import hasUserInfo from '../../hocs/has-user-info';
import Uploader from '../../components/uploader';
import ELEMIS_REPORT from '../../utils/static-configuration';

const messageStyles = {
  width: '100%',
  marginBottom: '10px',
};


class ReportUploadModal extends Component {
  constructor(props) {
    super(props);
    this.state = { uploaderState: 1, documentData: {} };
  }

  handleSubmit = e => {
    e.preventDefault();
    const { onSubmit } = this.props;
    const { documentData } = this.state;
    if (documentData.filePath) {
      onSubmit(documentData);
    }
  }
  updateUploaderState = newUploaderState => {
    const { isSubmitting } = this.props;
    if (!isSubmitting) {
      this.setState({ uploaderState: newUploaderState });
    }
  }
  uploadDataCallback = documentData => {
    this.setState({ documentData });
  }
  render() {
    const {
      onClose,
      isSubmitting,
      error,
    } = this.props;

    const {
      uploaderState,
      documentData,
    } = this.state;
    console.log('Document data: ', documentData);
    const submitDisabled = isSubmitting || !documentData.filePath;
    console.log('Submit Disabled: ', isSubmitting, !documentData.filePath, submitDisabled);
    return (
      <div>
        <DyzioModal headerText="Import" size="small" onClose={onClose}>
          <div >
            {error && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Message
                  fluid
                  style={messageStyles}
                  icon="frown"
                  error
                  header="Error"
                  content={error}
                />
              </div>
            )}

            {
              isSubmitting && <Message
                fluid
                style={messageStyles}
                icon="clock outline"
                color="orange"
                header="Importing"
                content="Report is being imported. Please refresh the page after few minutes."
              />
            }
            <h4>Upload report</h4>
            <h5 style={{ color: 'rgba(0,0,0,0.4)' }}>Please select a .xlsx report file</h5>
            <Divider />
            <Uploader
              uploaderState={uploaderState}
              updateUploaderState={this.updateUploaderState}
              docType={ELEMIS_REPORT}
              uploadDataCallback={this.uploadDataCallback}
            />
            <div
              className="flex"
              style={{
                justifyContent: 'flex-end',
                padding: '10px 0px 10px 0px',
              }}
            >
              <Button
                loading={isSubmitting}
                disabled={submitDisabled}
                color="pink"
                type="submit"
                size="medium"
                onClick={this.handleSubmit}
              >
                Submit
              </Button>
            </div>
          </div>
        </DyzioModal>
      </div>
    );
  }
}

ReportUploadModal.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  error: PropTypes.any,
};
ReportUploadModal.defaultProps = {
  onClose: _.noop,
  onSubmit: _.noop,
  isSubmitting: false,
  error: null,
};
export default compose(
  hasUserInfo,
)(ReportUploadModal);



/** WEBPACK FOOTER **
 ** ./src/components/report-upload-modal/index.js
 **/